import React, { useContext, useEffect, useState } from 'react'
import CourseBatchesList from './CourseBatchesList'
import GetActiveBatches from '../../actions/course/GetActiveBatches'
import { AuthContext } from '../../context/AuthContext'
import { useDispatch, useSelector } from 'react-redux'
import Localbase from 'localbase';
import { useActionsContext } from '../../context/ActionsContext'

const ActiveBatchesList = () => {

     const { rowsPerPage, setRowsPerPage } = useActionsContext();
    const value = useSelector((state) => state.modalHandler);
    const { user } = useContext(AuthContext);
    const [batches, setBatches] = useState(null);
    const [total, setTotal] = useState(null);
    const db = new Localbase("db");
    const dispatch = useDispatch()

    const GetBatches = async () => {
        dispatch({ type: "LOADING" });
    
        try {
            const res = await GetActiveBatches({
                payload: {
                    session: user.SessionId,
                    status: "active",
                    limit: rowsPerPage, 
                }
            });
    
            if (res && res.status === "success") {
                dispatch({ type: "DONE_LOADING" });
                setBatches(res.data || []); // Fallback to empty array if data is null
                setTotal(res.total_batches || 0); // Use total_batches from response, fallback to 0
                // Save to Localbase
                await db.collection("batches").doc("active_batches").set({
                    batches: res.data || [],
                    total: res.total_batches || 0
                });
            } else {
                dispatch({ type: "ERROR", payload: res?.error?.message || "Failed to fetch batches" });
            }
        } catch (error) {
            dispatch({ type: "ERROR", payload: error.message || "Error fetching batches" });
            console.error("Error fetching batches:", error);
        }
    };
    
    useEffect(() => {
        // Fetch batches from Localbase first
        db.collection("batches").doc("active_batches").get().then(data => {
            if (data) {
                setBatches(data.batches);
                setTotal({ total_batches: data.total });
            }
        });
    
        // Then call the API to fetch updated data
        GetBatches();
    }, [rowsPerPage]);
    
    useEffect(() => {
        if (value.functionName === 'batches') {
            setBatches(null);
            GetBatches();
        }
    }, [value]);
    
    
  return (
<>
{batches?
<>


<CourseBatchesList addbatch={false} batches={batches}/>
</>:
<>


</>}
</>
  )
}

export default ActiveBatchesList